const config = [
  // 账号管理 1
  {
    component: 'SystemSettings',
    name: '账号管理',
    id: '100',
    active: true, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: undefined, // 当前页码
    pageSize: undefined, // 每页数量
    pageSizes: undefined,
    defaultPageSize: undefined, // 默认每页数量 用户重置页面数量
    total: undefined, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: undefined, // 当前表格是否多选
    api: undefined,
    tableColumnsName: undefined, // 当前页面 table的取值
    filters: {
      left: undefined,
      right: undefined
    },
    children: undefined,
    tableButtons: undefined
  },
  {
    component: 'regional',
    name: '区域设置',
    id: '200',
    active: false, // 当前激活项
    cached: false, // 是否缓存
    state: undefined,
    pageNum: undefined, // 当前页码
    pageSize: undefined, // 每页数量
    pageSizes: undefined,
    defaultPageSize: undefined, // 默认每页数量 用户重置页面数量
    total: undefined, // 总条数
    tableData: undefined, // 当前页的数据集合
    needSelection: undefined, // 当前表格是否多选
    api: undefined,
    tableColumnsName: undefined, // 当前页面 table的取值
    filters: {
      left: undefined,
      right: undefined
    },
    children: undefined,
    tableButtons: undefined
  }
  // {
  //   component: 'siteFence',
  //   name: '站点围栏绘制',
  //   id: '300',
  //   active: false, // 当前激活项
  //   cached: false, // 是否缓存
  //   state: undefined,
  //   pageNum: undefined, // 当前页码
  //   pageSize: undefined, // 每页数量
  //   pageSizes: undefined,
  //   defaultPageSize: undefined, // 默认每页数量 用户重置页面数量
  //   total: undefined, // 总条数
  //   tableData: undefined, // 当前页的数据集合
  //   needSelection: undefined, // 当前表格是否多选
  //   api: undefined,
  //   tableColumnsName: undefined, // 当前页面 table的取值
  //   filters: {
  //     left: undefined,
  //     right: undefined
  //   },
  //   children: undefined,
  //   tableButtons: undefined
  // }
  // {
  //   component: 'noEntryFence',
  //   name: '禁行区绘制',
  //   id: '400',
  //   active: false, // 当前激活项
  //   cached: false, // 是否缓存
  //   state: undefined,
  //   pageNum: undefined, // 当前页码
  //   pageSize: undefined, // 每页数量
  //   pageSizes: undefined,
  //   defaultPageSize: undefined, // 默认每页数量 用户重置页面数量
  //   total: undefined, // 总条数
  //   tableData: undefined, // 当前页的数据集合
  //   needSelection: undefined, // 当前表格是否多选
  //   api: undefined,
  //   tableColumnsName: undefined, // 当前页面 table的取值
  //   filters: {
  //     left: undefined,
  //     right: undefined
  //   },
  //   children: undefined,
  //   tableButtons: undefined
  // }
]

export default config
